import { AProvider } from "src/framework/providers/AProvider";

class ComponenteAtributosProvider extends AProvider {
    constructor() {
        super("/estoque/componentes/atributos");
    }
}

export { ComponenteAtributosProvider }